import Button from '~/components/Button';
import { trackEvent } from '~/helpers/tracking';
import PhoneBannerCTAStyles from './PhoneBannerCTAStyles';

interface Props {
  enabled?: string;
  description?: string;
  ctaCopy?: string;
  button?: {
    backgroundColor: string;
    borderColor: string;
    textColor: string;
    hoverBackgroundColor: string;
    hoverBorderColor: string;
    hoverTextColor: string;
  };
  callInNumber?: string;
  inline?: boolean;
  className?: string;
  hideOnMobile?: boolean;
}

const PhoneBannerCTA: React.FC<Props> = ({
  description,
  button,
  callInNumber,
  inline = true,
  ctaCopy,
  className,
  hideOnMobile = true,
}) => {
  const fallbackCtaCopy = callInNumber ? `${callInNumber}` : 'Call to Order';
  const handleCallToOrder = () => {
    trackEvent({ action: 'callToOrder' });
    window.location.href = `tel:${callInNumber}`;
  };
  return (
    <PhoneBannerCTAStyles inline={inline} hideOnMobile={hideOnMobile} className={className}>
      <div className="cta-editable-banner" data-testid="cta-editable-banner">
        <p>{description || 'Talk to a Frontier specialist to find the right plan for your home.'}</p>
        <Button onClick={handleCallToOrder} buttonConfig={button}>
          {ctaCopy || fallbackCtaCopy}
        </Button>
      </div>
    </PhoneBannerCTAStyles>
  );
};

PhoneBannerCTA.displayName = 'PhoneBannerCTA';

export default PhoneBannerCTA;
